// extracted by mini-css-extract-plugin
export default {"component":"b1zjz8","icon":"c1zjz8"};